<template>
    <transition name="videodialog">
        <div v-show="value" class="codics-aonaer-info-sys-video-dialog-body" @click="changeShow">
            <div @click.stop="1">
                <video id="my-video" ref="videoPlayer" class="codics-aonaer-info-sys-video-dialog-video-js video-js"
                    @click.stop="(e) => e.stopPropagation()" controls preload="auto" width="850" height="450">
                    <source :src="url" type="video/mp4">
                </video>
            </div>
            <div class="codics-aonaer-info-sys-video-dialog-close"></div>
        </div>
    </transition>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        url: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            nowTime: 0,
            player: null
        }
    },
    mounted() {
        this.player = videojs(this.$refs.videoPlayer);
    },
    watch: {
        value(val) {
            if (val) {
                this.player.play();
            } else {
                this.player.pause();
            }
        }
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }
    },
    methods: {
        playVideo(url) {
            if (this.player) {
                this.player.src(url);
                this.player.play();
            }
        },
        changeShow(e) {
            e.stopPropagation();
            if (new Date().getTime() - this.nowTime > 1000) {
                this.nowTime = new Date().getTime();
                this.$emit('input', !this.value);
            }
            return false;
        }
    }
}
</script>

<style>
/* 弹窗体 */
.codics-aonaer-info-sys-video-dialog-body {
    height: 100%;
    width: 100%;
    transition: .3s;
    position: fixed;
    z-index: 1111;
    top: 0;
    left: 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(3px);
    /* -webkit-backdrop-filter: blur(3px); */
}

.codics-aonaer-info-sys-video-dialog-body-card {
    height: 400px;
    width: 900px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #FFF;
    pointer-events: all;
}

.codics-aonaer-info-sys-video-dialog-video-js {
    height: 450px;
    width: 850px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #333;
    pointer-events: all;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-video-dialog-close {
    height: 22px;
    width: 22px;
    position: absolute;
    margin: auto;
    top: -450px;
    left: 0;
    right: -950px;
    bottom: 0;
    cursor: pointer;
}

.codics-aonaer-info-sys-video-dialog-close:hover::after {
    transform: rotate(225deg);
    background: rgba(255, 136, 0, 1);
}

.codics-aonaer-info-sys-video-dialog-close:hover::before {
    transform: rotate(315deg);
    background: rgba(255, 136, 0, 1);
}

.codics-aonaer-info-sys-video-dialog-close::before,
.codics-aonaer-info-sys-video-dialog-close::after {
    content: '';
    height: 22px;
    width: 1px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transform: rotate(45deg);
    background: rgba(255, 255, 255, 1);
    border-radius: .5px;
    transition: .3s;
}

.codics-aonaer-info-sys-video-dialog-close::after {
    transform: rotate(-45deg);
}

/* 定义进入和离开的过渡效果 */
.videodialog-enter-active,
.videodialog-leave-active {
    transition: .3s;
}

.videodialog-enter,
.videodialog-leave-to {
    opacity: 0;
}

@media (max-width:768px) {}
</style>